module.exports = __webpack_public_path__ + "static/media/hall-P12-2026.c4f20179.svg";